/**
 * True when the demo runs inside a frame (embedded in the platform), false
 * when it is the top-level page. Cross-origin access to `window.top` can throw;
 * that is only ever the case inside a frame, so it counts as embedded.
 */
export function isEmbedded(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
